import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";

import type { ArticleStatus } from "~/lib/article-status";

const CHIP_COLOR: Record<ArticleStatus, "default" | "warning" | "success"> = {
  draft: "default",
  scheduled: "warning",
  published: "success",
};

/** The editorial state, as a compact label for the list. */
export function StatusChip({ status }: { status: ArticleStatus }) {
  const { t } = useTranslation();
  return (
    <Chip
      label={t(`articles.status.${status}`)}
      color={CHIP_COLOR[status]}
      variant="outlined"
      size="small"
    />
  );
}
